import React from 'react'
import AgriImport from './_agri-import'

export default class DairyImport extends React.Component {
  render = () => {
    const { props } = this

    const aprops = {
      resource: '/dairy_import_licenses',
      form_key: 'dairy_import_license',
      _sid: 'dairy import license',
      service: props.service,
      form_name: 'Dairy',
      importProps: {
        metric_list: [
          'Each Per Item',
          'Cases per item',
          'Bags per item',
          'Bins per item',
          'Pounds per item',
          'Sacks per item',
        ],
        hide_scientific: true,
      },
      ...props,
    }

    return (
      <>
        <AgriImport {...aprops} />
      </>
    )
  }
}
